import React from 'react';
import { Form } from 'react-bootstrap';
import { InputMaskDate, InputMaskPhone } from '../../../../Helpers/Formatters';
import { SelectInput, StyledRadioInput, TextInput } from '../../../../Helpers/Inputs';
import NotesPagesNotification from '../../../../../icons/NotesPagesNotification.svg';
import County from '../../../../Helpers/Lists/County';
import States from '../../../../Helpers/Lists/States';
import { GenderOptions, MaritalStatusOptions, TobaccoOptions } from '../../../../Common/Constant';
import TitleComponent from '../../../../Common/TitleComponent';
import { InsuredRelationshipWithOwnerOptions } from '../../../../Helpers/Lists/InsuredRelationshipWithOwnerOptions';
import { getSortFieldName, handleCheckDisableField } from '../../../SharedComponents/RetrieveAccount/SubComponents/PrefillABLTCInsuredInfo';
import { getNormalizedOptionValue } from '../../SubComponents/SelectOptions';

export default function InsuredBasicInfoForm(props) {
    const { index, errors, register, setValue, triggerValidation, isSurvivorshipPolicy } = props;

    const isOther = props.formState.insuredInfo[index].isOther;

    const handleValueChange = (field, value) => {
        const newForm = [...props.formState.insuredInfo];
        setValue(field, value)
        triggerValidation(field);
        if (field === `insuredInfo[${index}].birthdate`) {
            if (props.isBirthDateError) {
                props.setIsBirthDateError(false);
            }
        }
        props.onChange({ ...newForm[props.index], [getSortFieldName(field)]: value }, getSortFieldName(field))
    }

    const renderTextInput = (name, label, value, disabled = false, inputMask = null) =>
        <TextInput
            name={name}
            id={name}
            label={label}
            value={value}
            onChange={e => handleValueChange(name, e.target.value)}
            errors={errors.insuredInfo && errors.insuredInfo[index] && errors.insuredInfo[index][getSortFieldName(name)]}
            inputRef={register}
            disabled={disabled && handleCheckDisableField(name, index, props.fullFormState)}
            InputProps={inputMask !== null ? {
                inputComponent: inputMask,
            } : {}}
        />

    const renderRadioInput = (name, options, value, label, disabled = false) =>
        <StyledRadioInput
            name={name}
            id={name}
            label={label}
            inputRef={register}
            value={value}
            options={options}
            onChange={e => handleValueChange(name, e)}
            disabled={disabled && handleCheckDisableField(name, index, props.fullFormState)}
            errors={errors.insuredInfo && errors.insuredInfo[index] && errors.insuredInfo[index][getSortFieldName(name)]}
        />

    const renderSelectInput = (name, label, value, selectOptions, hideEmptyOption = false, disabled = false) => {
        return (
            <SelectInput
                name={name}
                id={name}
                value={value}
                onChange={(e) => handleValueChange(name, e.target.value)}
                label={label}
                selectOptions={selectOptions}
                errors={errors.insuredInfo && errors.insuredInfo[index] && errors.insuredInfo[index][getSortFieldName(name)]}
                inputRef={register}
                hideEmptyOption={hideEmptyOption}
                disabled={disabled && handleCheckDisableField(name, index, props.fullFormState)}
            />
        )
    }

    return (
        <React.Fragment>
            <TitleComponent icon={NotesPagesNotification} title={`Proposed Insured ${isSurvivorshipPolicy ? (index === 0 ? 1 : 2) : ''} Information`} />
            <Form.Group>
                {renderTextInput(`insuredInfo[${index}].proposedInsuredFirstName`, 'First Name', props.formState.insuredInfo[index].proposedInsuredFirstName, !isOther)}
            </Form.Group>
            <Form.Group>
                {renderTextInput(`insuredInfo[${index}].proposedInsuredMiddleInitial`, 'Middle Initial', props.formState.insuredInfo[index].proposedInsuredMiddleInitial, props.formState.insuredInfo[index].middleNameDisable)}
            </Form.Group>
            <Form.Group>
                {renderTextInput(`insuredInfo[${index}].proposedInsuredLastName`, 'Last Name', props.formState.insuredInfo[index].proposedInsuredLastName, !isOther)}
            </Form.Group>
            <Form.Group className='mb-1'>
                {renderRadioInput(`insuredInfo[${index}].gender`, GenderOptions, getNormalizedOptionValue(props.formState.insuredInfo[index].gender, GenderOptions), '', !isOther)}
            </Form.Group>
            <Form.Group>
                {renderTextInput(`insuredInfo[${index}].birthdate`, 'Date of Birth', props.formState.insuredInfo[index].birthdate, !isOther, InputMaskDate)}
                {(isSurvivorshipPolicy && props.isBirthDateError) && <div className='errorMessage'>CareMatters Together age difference between insureds is 25 years. Please contact your Covr sales team for assistance.</div>}
            </Form.Group>
            <Form.Group>
                {renderSelectInput(`insuredInfo[${index}].state`, 'Resident State', props.formState.insuredInfo[index].state, States(), true, !isOther)}
            </Form.Group>
            {props.formState.insuredInfo[index].state === "CA" &&
                <Form.Group>
                    {renderSelectInput(`insuredInfo[${index}].county`, "County", props.formState.insuredInfo[index].county, County())}
                </Form.Group>
            }
            <Form.Group className='mb-1'>
                {renderRadioInput(`insuredInfo[${index}].maritalStatus`, MaritalStatusOptions, props.formState.insuredInfo[index].maritalStatus)}
            </Form.Group>
            <Form.Group>
                {renderSelectInput(`insuredInfo[${index}].tobacco`, 'Tobacco Use', props.formState.insuredInfo[index].tobacco, TobaccoOptions)}
            </Form.Group>
            {isOther && <Form.Group>
                {renderTextInput(`insuredInfo[${index}].proposedInsuredEmail`, 'Email Address', props.formState.insuredInfo[index].proposedInsuredEmail)}
            </Form.Group>
            }
            {isOther && <Form.Group>
                {renderTextInput(`insuredInfo[${index}].proposedInsuredPhone`, 'Phone', props.formState.insuredInfo[index].proposedInsuredPhone, false, InputMaskPhone)}
            </Form.Group>
            }
            {!isSurvivorshipPolicy && props.isMSEnableRelationshipToOwner &&
                <Form.Group>
                    {renderSelectInput(`insuredInfo[${index}].insuredRelationshipWithOwner`, 'Relationship with owner', props.formState.insuredInfo[index].insuredRelationshipWithOwner, InsuredRelationshipWithOwnerOptions, true, props.isInsuredRelationshipWithOwnerDisabled)}
                </Form.Group>
            }
        </React.Fragment>
    )
};



// WEBPACK FOOTER //
// ./src/components/Product/ABLTC/RequestIllustration/SubComponents/InsuredBasicInfoForm.js